import { Roles } from '../../models/User';
import type { ActiveFocusUnit } from '../../businessLogicService/focusService';

export interface RoadmapBucket {
  id: string;
  name: string;
  studentIds: string[];
}

interface RoleLike {
  name?: string | null;
}

interface TargetGroupLike {
  id: string;
  name?: string | null;
}

interface StudentTargetGroupLike {
  isCurrent?: boolean | null;
  targetGroup?: TargetGroupLike | null;
}

interface StudentLike {
  id?: string | null;
  isActive?: boolean | null;
  roles?: ReadonlyArray<RoleLike | null | undefined> | null;
  studentTargetGroups?: ReadonlyArray<StudentTargetGroupLike | null | undefined> | null;
}

export const bucketStudentsByRoadmap = (
  users: ReadonlyArray<StudentLike | null | undefined> | null | undefined,
): RoadmapBucket[] => {
  const byId = new Map<string, RoadmapBucket>();

  for (const user of users ?? []) {
    if (!user?.isActive) continue;
    if (!user.roles?.some(role => role?.name === Roles.STUDENT)) continue;

    const current = user.studentTargetGroups?.find(stg => stg?.isCurrent);
    const targetGroup = current?.targetGroup;
    if (!targetGroup?.id) continue;
    if (!user.id) continue;

    const existing = byId.get(targetGroup.id);
    if (existing) {
      existing.studentIds.push(user.id);
    } else {
      byId.set(targetGroup.id, { id: targetGroup.id, name: targetGroup.name ?? '', studentIds: [user.id] });
    }
  }

  return [...byId.values()].sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true }));
};

export const resolveDefaultRoadmapId = (activeFoci: ActiveFocusUnit[], buckets: RoadmapBucket[]): string => {
  const focusedRoadmapIds = new Set(activeFoci.map(f => f.roadmapId));
  return buckets.find(b => focusedRoadmapIds.has(b.id))?.id ?? buckets[0]?.id ?? '';
};

export const resolveDefaultUnitId = (activeFoci: ActiveFocusUnit[], roadmapId: string): string =>
  activeFoci.find(f => f.roadmapId === roadmapId)?.targetId ?? '';
